<template>
  <div class="award">
    <div class="container">
      <div class="award-box d-none d-md-block">我们的工作得到了行业的<span class="main-color">广泛认可</span></div>
      <div class="award-box d-md-none">
        我们的工作得到了
        <br />
        <span class="main-color">行业的广泛认可</span>
      </div>
      <div class="award-img-box d-none d-md-block">
        <img class="award-img" src="https://zealcomm-site-assets.zealcomm.cn/about/award.png" alt="" />
      </div>
      <div class="award-img-box d-md-none">
        <img class="award-img" src="https://zealcomm-site-assets.zealcomm.cn/about/award-mobile.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .award {
    padding: 100px 0;
    background: linear-gradient(92deg, #f8f8f8 0%, #a0e4db 50%, #edf8f8 99%, #eef8f8 100%);

    @include background("~assets/img/about/award-bg.png");

    .container {
      text-align: center;

      .award-box {
        color: #333;
        font-size: 36px;

        span.main-color {
          color: $main-color;
        }
      }

      .award-img-box {
        margin-top: 50px;

        .award-img {
          max-width: 548px;
        }
      }
    }
  }

  @media screen and (max-width: 992px) {
  }

  @media screen and (max-width: 768px) {
    .award {
      padding: 50px 0;
      background: rgba(237, 253, 248, 1);

      .container {
        text-align: center;

        .award-box {
          font-size: 18px;
        }

        .award-img-box {
          margin-top: 24px;

          .award-img {
            max-width: 266px;
          }
        }
      }
    }
  }
</style>
